<template>
  <div class="wrapper">
    <el-card class="kilometre" :body-style="{ padding: '5px 10px' }">
      <el-row>
        <el-radio v-model="radio1" label="0">
          公里数计费
        </el-radio>
        <el-button
          v-if="getLimit('valuation_addKm_button')"
          type="primary"
          plain
          style="float:right;width:200px;"
          @click="addKilometre"
        >
          + 增加公里数
        </el-button>
      </el-row>
      <el-form
        ref="KMruleForm"
        :model="kilometreForm"
        class="kmForm"
        :rules="KMrules"
        label-width="0"
      >
        <el-form-item v-for="item in kilometreForm.domains" :key="item.key">
          <el-row :gutter="10" type="flex" align="middle">
            <el-col :span="6">
              <el-col :span="10">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="起步价"
                  placement="top"
                >
                  <el-form-item label-width="0" prop="price">
                    <el-input
                      v-model.number="item.price"
                      placeholder="起步价"
                      type="number"
                      min="0.00"
                      step="0.01"
                      @keyup.native="
                        e =>
                          (e.target.value = e.target.value.replace(
                            /([0-9]+\.[0-9]{2})[0-9]*/,
                            '$1'
                          ))
                      "
                    >
                      <i slot="suffix">元</i>
                    </el-input>
                  </el-form-item>
                </el-tooltip>
              </el-col>
              <el-col :span="14">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="起步公里数"
                  placement="top"
                >
                  <el-form-item
                    label="每"
                    label-width="25px"
                    style="margin-left:8px;"
                    prop="limitEnd"
                  >
                    <el-input
                      v-model.number="item.limitEnd"
                      placeholder="起步公里数"
                      type="number"
                      min="0.00"
                      step="0.01"
                      @keyup.native="
                        e =>
                          (e.target.value = e.target.value.replace(
                            /([0-9]+\.[0-9]{2})[0-9]*/,
                            '$1'
                          ))
                      "
                    >
                      <i slot="suffix">Km</i>
                    </el-input>
                  </el-form-item>
                </el-tooltip>
              </el-col>
            </el-col>
            <el-col :span="1" class="iconCount">
              <i class="el-icon-plus" />
            </el-col>
            <el-col :span="4">
              <el-tooltip
                class="item"
                effect="dark"
                content="公里单价"
                placement="top"
              >
                <el-form-item label-width="0" prop="unitPrice">
                  <el-input
                    v-model.number="item.unitPrice"
                    placeholder="公里单价"
                    type="number"
                    min="0.00"
                    step="0.01"
                    @keyup.native="
                      e =>
                        (e.target.value = e.target.value.replace(
                          /([0-9]+\.[0-9]{2})[0-9]*/,
                          '$1'
                        ))
                    "
                  >
                    <i slot="suffix">元/Km</i>
                  </el-input>
                </el-form-item>
              </el-tooltip>
            </el-col>
            <el-col :span="1" class="iconCount">
              <i class="el-icon-close" />
            </el-col>
            <el-col :span="5">
              <el-tooltip
                class="item"
                effect="dark"
                content="公里数-起步公里数"
                placement="top"
              >
                <el-form-item label-width="0">
                  <el-input placeholder="公里数-起步公里数" disabled>
                    <i slot="suffix">Km</i>
                  </el-input>
                </el-form-item>
              </el-tooltip>
            </el-col>
            <el-col :span="1" class="iconCount">
              <i>=</i>
            </el-col>
            <el-col :span="6">
              <el-col :span="kilometreWidth">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="单票运费"
                  placement="top"
                >
                  <el-form-item label-width="0">
                    <el-input placeholder="单票运费" disabled>
                      <i slot="suffix">元</i>
                    </el-input>
                  </el-form-item>
                </el-tooltip>
              </el-col>
              <template v-if="isRemoveKilometre">
                <el-col :span="2">
                  <el-button type="text" @click="removeKilometre(item)">
                    删除
                  </el-button>
                </el-col>
              </template>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
    </el-card>
    <template v-for="(item, index) in priceList">
      <vehiclePrice :key="'price' + index" :parent-data="item" />
    </template>
    <el-card class="kilometre" :body-style="{ padding: '5px 10px' }">
      <el-form
        ref="KMruleForm"
        :model="kilometreForm"
        class="kmForm"
        :rules="KMrules"
        label-width="0"
      >
        <el-row :gutter="10">
          <el-col :span="6">
            <el-radio v-model="radio1" label="0" style="margin-bottom:20px;">
              装卸费
            </el-radio>
            <el-tooltip
              class="item"
              effect="dark"
              content="装卸费"
              placement="top"
            >
              <el-select
                v-model="kilometreForm.status"
                clearable
                placeholder="请选择"
              >
                <el-option value="0" label="承运方付" />
              </el-select>
            </el-tooltip>
          </el-col>
          <el-col :span="6">
            <vxe-table
              ref="xTable"
              size="small"
              border
              show-overflow
              keep-source
              :data="loadData"
              :edit-config="{ trigger: 'click', mode: 'row' }"
              @edit-closed="saveEvent"
            >
              <vxe-table-column
                field="price"
                title="装卸费"
                :edit-render="{
                  name: '$input',
                  props: { type: 'number', min: '0', max: '999999' }
                }"
              />
              <vxe-table-column
                field="limitEnd"
                title="单位"
                :edit-render="{
                  name: '$input',
                  props: { type: 'number', min: '0', max: '999999' }
                }"
              />
            </vxe-table>
          </el-col>
          <el-col :span="12">
            <el-col :span="4">
              <el-form-item>
                <el-radio v-model="radio1" label="0">
                  装卸费
                </el-radio>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-tooltip
                class="item"
                effect="dark"
                content="金额"
                placement="top"
              >
                <el-form-item>
                  <el-input placeholder="金额">
                    <i slot="suffix">元</i>
                  </el-input>
                </el-form-item>
              </el-tooltip>
            </el-col>
            <el-col :span="1">
              <el-form-item>
                <span>或</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-tooltip
                class="item"
                effect="dark"
                content="金额"
                placement="top"
              >
                <el-form-item>
                  <el-input placeholder="" />
                </el-form-item>
              </el-tooltip>
            </el-col>
            <el-col :span="7">
              <el-tooltip
                class="item"
                effect="dark"
                content="收费方式"
                placement="top"
              >
                <el-form-item>
                  <el-select
                    v-model="kilometreForm.status"
                    clearable
                    placeholder="请选择"
                  >
                    <el-option value="0" label="(百分比)%" />
                  </el-select>
                </el-form-item>
              </el-tooltip>
            </el-col>
            <el-col :span="7">
              <el-tooltip
                class="item"
                effect="dark"
                content="付款方"
                placement="top"
              >
                <el-form-item>
                  <el-select
                    v-model="kilometreForm.status"
                    clearable
                    placeholder="请选择"
                  >
                    <el-option value="0" label="承运方付" />
                  </el-select>
                </el-form-item>
              </el-tooltip>
            </el-col>
            <el-col :span="24">
              <el-form-item>
                <el-checkbox
                  v-model="kilometreForm.isHanding"
                  true-label="1"
                  false-label="0"
                >
                  综合最大值
                </el-checkbox>
              </el-form-item>
            </el-col>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import vehiclePrice from "./components/vehiclePrice.vue";
export default {
  components: {
    vehiclePrice
  },
  data() {
    return {
      lineWidth: 22,
      weightWidth: 19,
      kilometreWidth: 22,
      isRemoveKilometre: true,
      radio1: "0",
      kilometreForm: {
        // 公里计价
        domains: [
          {
            defaultBillingMethod: "0",
            limitEnd: "", //千克/方/件/点计量范围
            limitFrom: 0, //千克/方/件/点计量起始范围,
            points: 0, //百分比
            price: "",
            priceItem: "01", //价格项目（01配送计费，02运输计费）
            priceName: "公里数计费",
            priceType: "0", //费用类别（0, "公里数计费",1,"重量计费",2, "件数计费",3, "点数计费",4, "体积计费",5, "包车计费",6, "装卸费",7, "车数计费",8, "线路计费",9, "加急费",10, "信息费",11, "代收款手续费",12, "车型费用")13, "综合最大值";）
            rangeEnd: "", //组合计费 里程终止范围
            rangeFrom: "", //组合计费 里程起始范围
            rangeUnitPrice: 0,
            routelineCode: "", //线路code或者是车型code
            shipmentUserCode: "", //托运人用户code，对应sys_party表code
            unit: 0, //单位（非必传）
            unitPrice: "" //（单价）
          }
        ]
      },
      KMrules: {
        price: [{ type: "number", message: "起步价必须为数字值" }],
        limitEnd: [{ type: "number", message: "起步公里数必须为数字值" }],
        unitPrice: [{ type: "number", message: "公里单价必须为数字值" }]
      },
      priceList: [
        {
          title: "重量计费",
          Unit: "吨数",
          tableData: [
            { price: 10, limitEnd: 20 },
            { price: 50, limitEnd: 80 },
            { price: 100, limitEnd: 160 }
          ]
        },
        {
          title: "体积计费",
          Unit: "体积",
          tableData: [
            { price: 10, limitEnd: 20 },
            { price: 50, limitEnd: 80 },
            { price: 100, limitEnd: 160 }
          ]
        },
        {
          title: "件数计费",
          Unit: "件数",
          tableData: [
            { price: 10, limitEnd: 20 },
            { price: 50, limitEnd: 80 },
            { price: 100, limitEnd: 160 }
          ]
        },
        {
          title: "车数计费",
          Unit: "车数",
          tableData: [
            { price: 10, limitEnd: 20 },
            { price: 50, limitEnd: 80 },
            { price: 100, limitEnd: 160 }
          ]
        }
      ],
      loadData: [],
      valuation_removeKm_button: true
    };
  },
  created() {
    this.valuation_removeKm_button = this.getLimit("valuation_removeKm_button");
  },
  methods: {
    //增加公里数计费
    addKilometre() {
      this.kilometreForm.domains.push({
        key: Date.now(),
        defaultBillingMethod: "0",
        limitEnd: "", //千克/方/件/点计量范围
        limitFrom: 0, //千克/方/件/点计量起始范围,
        points: 0, //百分比
        price: "",
        priceItem: "01", //价格项目（01配送计费，02运输计费）
        priceName: "公里数计费",
        priceType: "0", //费用类别（0, "公里数计费",1,"重量计费",2, "件数��费",3, "点数计费",4, "体积计费",5, "包车计费",6, "装卸费",7, "车数计费",8, "线路计费",9, "加急费",10, "信息费",11, "代收款手续费",12, "车型费用")13, "综合最大值";）
        rangeEnd: "", //组合计费 里程终止范围
        rangeFrom: "", //组合计费 里程起始范围
        rangeUnitPrice: 0,
        routelineCode: "", //线路code或者是车型code
        shipmentUserCode: "", //托运人用户code，对应sys_party表code
        unit: 0, //单位（非必传）
        unitPrice: "" //（单价）
      });
      this.isRemoveKilometre = true; //&& this.valuation_removeKm_button;
      this.kilometreWidth = 22;
    },
    // 删除公里数
    removeKilometre(item) {
      var delId;
      this.kilometreForm.domains.map((val, index) => {
        if (val.key == item.key) {
          delId = index;
        }
      });
      if (this.kilometreForm.domains.length > 1) {
        this.kilometreForm.domains.splice(delId, 1);
      } else {
        this.isRemoveKilometre = false;
        this.kilometreWidth = 24;
        this.$refs.KMruleForm.resetFields();
      }
    },
    // 编辑保存
    saveEvent() {}
  }
};
</script>
<style scoped lang="scss">
.kmForm {
  margin-top: 10px;
  // padding: 0 20px;
}
.iconCount {
  text-align: center;
}
.el-card {
  margin-bottom: 10px;
}
</style>
